// Custom modules
import http from "./httpService";
import { apiServicesURL } from "./config.json";

export async function getData() {
  // This is an array of services we can offer displayed on the services page
  const results = await http.get(apiServicesURL);
  return results.data;
}

export default {
  getData,
};
